import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => {
  const { right, paddingLR, left, marginLR } = theme.mixins;

  return {
    filterSection: {
      paddingBottom: theme.spacing(9),
      [theme.breakpoints.up('lg')]: {
        background: theme.mixins.LightOrange(),
        paddingBottom: '0',
      },
      '&.ADEventFilter': {
        backgroundColor: '#fff',
        '[dir="rtl"] &': {
          textAlign: 'right'
        },
        '& .AdEventColor': {
          border: 'none',
          overflow: 'hidden',
          padding: `0 ${pxToRem(16)}`,
          marginTop: pxToRem(-8),
          [theme.breakpoints.down('md')]: {
            marginTop: pxToRem(-16),
          },
          '& label': {
            '& p': {
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(16)
              },
              '[dir="rtl"] &': {
                marginRight: pxToRem(8)
              },
            }
          },
          '&:first-child': {
            marginTop: pxToRem(0),
          },
          '& .MuiCheckbox-root': {
            '& + label': {
              color: '#706C6C',
            },
            '& .checkedIcon': {
              '&:before': {
                top: pxToRem(4),
                height: pxToRem(9),
                ...theme.mixins.left(3),
                width: pxToRem(16),
                borderWidth: '2px',
              },
            },
            '& .MuiIconButton-label': {
              '& span': {
                borderRadius: pxToRem(4),
                borderColor: '#565A5C',
                backgroundColor: 'transparent',
                color: '#706C6C',
                '&.checkedIcon': {
                  borderColor: 'rgba(255, 135, 7, 1)',
                  background: 'rgba(255, 135, 7, 1)',
                }
              }
            }
          },
          '& .showlessWrapper': {
            display: 'flex',
            '& .more , .less': {
              color: '#FF8707',
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(16)
              },
              '&:after': {
                display: 'none'
              }
            },
          },

          '& h2': {
            color: '#000000',
            [theme.breakpoints.down('md')]: {
              marginTop: pxToRem(24),
              fontSize: pxToRem(16)
            },
          },
          '& .checkedIcon': {
            border: "1px solid rgba(255, 135, 7, 1)",
            background: 'rgba(255, 135, 7, 1)',
          }
        },

      }
    },
    drawerWrapper: {
      width: '100%',
    },
    filterMobileContainer: {
      width: '100%',

      '& .MuiPaper-root': {
        width: '100%',
      },
    },
    heading: {
      color: theme.mixins.neroBlack(700),
      '&.hide': {
        display: 'none'
      }
    },
    togglefilterButton: {
      position: 'fixed',
      bottom: pxToRem(16),
      ...right(pxToRem(24)),
      zIndex: 100,

      '& button': {
        padding: `${pxToRem(8)} ${pxToRem(25)}`,
        '@media (max-width: 414px)': {
          ...theme.mixins.paddingRight(pxToRem(21)),
          ...theme.mixins.paddingLeft(pxToRem(14)),
        },
        '@media (max-width: 374px)': {
          fontSize: fontSize.s0Rem,
          lineHeight: fontSize.s0Rem,
          color: 'transparent',
          ...theme.mixins.paddingRight(pxToRem(14)),
          ...theme.mixins.paddingLeft(pxToRem(14)),
        },
        ...theme.typography.body2Bold,
        color: theme.mixins.White(),

        '& .MuiButton-startIcon': {
          ...theme.mixins.marginLeft(pxToRem(0)),
          '@media (max-width: 374px)': {
            ...theme.mixins.marginRight(pxToRem(0)),
          },
        },
      },
    },
    crossIcon: {
      marginLeft: 10,
    },
    container: {
      padding: pxToRem(23),
      '&.ADContainer': {
        padding: `${pxToRem(16)} ${pxToRem(0)}`,
        ...theme.mixins.marginLeft(16),
        ...theme.mixins.marginRight(16),
        position: 'relative',
        [theme.breakpoints.down('md')]: {
          paddingBottom: pxToRem(24),
          border: 'none',
          '&:before': {
            width: '100%',
            left: '0',
            bottom: pxToRem(8),
            backgroundColor: '#E9E9E9',
            position: 'absolute',
            height: '1px',
            content: "''"
          }
        },
        '& h2': {
          color: '#000000'
        },
      },
      '& svg': {
        position: 'absolute',
        top: pxToRem(21),
        ...right(pxToRem(24)),
      },
      '& .MuiFormControlLabel-label': {
        color: theme.palette.text.tertiary,
      },
      '& .MuiFormControl-root': {
        margin: 0,
        width: '100%',
        '& .MuiFormLabel-root': {
          marginBottom: pxToRem(16),

          '&.MuiInputLabel-root': {
            position: 'relative',
            marginBottom: 0,
            top: pxToRem(0),
            [theme.breakpoints.up('lg')]: {
              top: pxToRem(0),
            },
          },
        },
        '& .MuiInputBase-root': {
          marginTop: 0,
        },
        '& .MuiFormGroup-root': {
          '&[role=radiogroup]': {
            flexDirection: 'column',

            '& .MuiFormControlLabel-root': {
              marginBottom: pxToRem(16),
              '& .MuiFormControlLabel-label': {
                marginLeft: 0,
              },
            },
          },
          '& .MuiFormControlLabel-root': {
            marginBottom: pxToRem(16),
            '& .MuiFormControlLabel-label': {
              marginLeft: 0,
            },
          },
          '& .MuiButtonBase-root.MuiRadio-root': {
            padding: 0,
            marginLeft: 11,
          },
          '& .MuiButtonBase-root.MuiRadio-root +  .MuiTypography-root': {
            paddingLeft: 8,
          },
        },
      },
      '&:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.border.divider}`,
      },
      '&:first-child': {
        textAlign: 'center',
        [theme.breakpoints.up('lg')]: {
          textAlign: 'initial',
          display: 'flex',
          justifyContent: 'space-between',
          color: theme.mixins.neroBlack(700),
        },
      },
    },
    eventColor: {
      '& .MuiFormGroup-root .more': {
        color: theme.mixins.DarkTurquoise(),
        '&::after': {
          borderColor: theme.mixins.DarkTurquoise(),
        },
      },
      '& .MuiFormGroup-root .less': {
        color: theme.mixins.DarkTurquoise(),
        '&::after': {
          borderColor: theme.mixins.DarkTurquoise(),
        },
      },
      '& .MuiCheckbox-root input:hover ~ span': {
        borderColor: theme.mixins.DarkTurquoise(),
      },
      '& .checkedIcon': {
        borderColor: theme.mixins.DarkTurquoise(),
        background: theme.mixins.DarkTurquoise(),
      },
    },
    eventBtnColor: {
      backgroundColor: theme.mixins.DarkTurquoise(),
    },
    dropdown: {
      padding: `${pxToRem(40)} ${pxToRem(23)}`,

      '& .MuiInputBase-root': {
        '&:hover, &:focus': {
          background: theme.palette.action.disabledBackground,
        },
        '& .MuiSelect-root': {
          '&:hover, &:focus': {
            background: 'transparent',
          },
        },
      },
    },
    mobileFooter: {
      display: 'flex',
      position: 'fixed',
      width: '100%',
      bottom: '0',
      left: '0',
      height: pxToRem(72),
      background: theme.palette.common.NearWhite,
      justifyContent: 'space-between',
      alignItems: 'center',
      ...paddingLR(pxToRem(24), pxToRem(24)),
      '&.ADfooterStyle': {
        backgroundColor: '#fff',
        paddingTop: pxToRem(8),
        paddingBottom: pxToRem(16),
        ...paddingLR(pxToRem(16), pxToRem(16)),
        '& button': {
          backgroundColor: '#FF8707',
          borderColor: '#FF8707',
          width: '100%',
          '& .MuiButton-label': {
            '& .btn-txt': {
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(16)
              },
            }
          }
        }
      },
      '& button': {
        padding: `${pxToRem(8)} ${pxToRem(25)}`,
        ...theme.typography.body2Bold,
        color: theme.mixins.White(),

        '& .MuiButton-label': {
          '& .MuiButton-endIcon': {
            marginLeft: 8,
          },
        },
      },
    },
    priceRangeText: {
      color: theme.mixins.Black(600),
    },
    resetButton: {
      position: 'absolute',
      top: pxToRem(16),
      ...left(pxToRem(16)),
      '&.hide': {
        display: 'none'
      }
    },
    ClearBTN: {
      position: 'absolute',
      top: pxToRem(16),
      ...right(pxToRem(16)),
      '&.AdClear': {
        [theme.breakpoints.down('md')]: {
          fontWeight: '400',
          fontSize: pxToRem(16)
        },
      }
    },
    filterText: {
      fontFamily: theme.custom.fontFamily.primaryBold,
      color: theme.mixins.RussianViolet(),
      '&.textLeft': {
        color: '#000',
        textAlign: 'left',
        '[dir="rtl"] &': {
          textAlign: 'right',
        },
        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(16)
        },
      }
    },
    viewAllMobileBtn: {
      position: 'fixed',
      bottom: pxToRem(16),
      ...left(pxToRem(24)),
      zIndex: 100,
      '&.hide': {
        display: 'none'
      },
      '& button': {
        backgroundColor: theme.mixins.Black(1000),
        '&:hover': {
          backgroundColor: theme.mixins.Black(1000),
        },
      },
    },
    AdMobileDrawer: {
      '& .MuiPaper-root': {
        [theme.breakpoints.down('md')]: {
          width: '100%'
        },

      }
    },
    viewAllBtnEndIcon: {
      ...theme.mixins.marginLeft(pxToRem(8)),
    },
    desktopViewAllSection: {
      backgroundColor: theme.mixins.LightOrange(),
      marginBottom: pxToRem(24),
      padding: pxToRem(24),
      color: theme.mixins.RussianViolet(),
    },
    listingText: {
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: pxToRem(20),

      '& p': {
        ...marginLR(pxToRem(3), 0),
      },
    },
    filterBTN: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: '1px solid #E9E9E9',
      padding: `${pxToRem(11)} ${pxToRem(16)}`,
      fontSize: pxToRem(12),
      lineHeight: pxToRem(16),
      textTransform: 'uppercase',
      width: 'max-content',
      '&:hover': {
        backgroundColor: '#E9E9E9',
        borderColor: '#E9E9E9',
        '& .btn-txt': {
          color: '#000000',
        }
      },
      '&.calender': {
        minWidth: pxToRem(40),
        padding: `${pxToRem(7)}`,
        height: '100%',
        '& + .react-datepicker__close-icon': {
          opacity: 0,
          '[dir="rtl"] &': {
            right: 'auto',
            left: '6px'
          },
          '&:after': {
            backgroundColor: 'transparent',
            fontSize: '25px'
          }
        },
        '& .btn-txt': {
          alignItems: 'center',
          display: 'flex',
        },
        '&.activeCalender': {
          backgroundColor: '#FF8707',
          borderColor: '#FF8707',
          minHeight: pxToRem(40),
          padding: `${pxToRem(9)} ${pxToRem(16)}`,
          '& + .react-datepicker__close-icon': {
            opacity: 1
          },
          '& .btn-txt': {
            display: 'flex',
            alignItems: 'center',
            color: '#fff',
            '& .crossOn': {
              ...theme.mixins.marginLeft(8),
              display: 'flex'
            },
            '& svg': {
              ...theme.mixins.marginRight(8),
              '& path': {
                stroke: '#FFFFFF',
              }
            }
          }
        }
      },
      '&.active': {
        backgroundColor: '#FF8707',
        borderColor: '#FF8707',
        '&:hover': {
          '& .btn-txt': {
            color: '#fff',
          }
        },
        '& .btn-txt': {
          alignItems: 'center',
          display: 'flex',
          color: '#FFFFFF',
          '& svg': {
            ...theme.mixins.marginLeft(8),
          }
        }
      },
      '&.showEvents': {
        backgroundColor: '#FF8707',
        width: '100%',
        padding: `${pxToRem(11)} ${pxToRem(16)} !important`,
        height: pxToRem(40),
        '&:hover': {
          '& .btn-txt': {
            color: '#fff',
          }
        },
        '& .btn-txt': {
          fontSize: pxToRem(16),
          lineHeight: pxToRem(24),
          color: '#fff',
        }
      },
      '&.filters': {
        backgroundColor: '#FF8707',
        borderColor: '#FF8707',
        '&:hover': {
          '& .btn-txt': {
            color: '#FFFFFF',
          }
        },
        [theme.breakpoints.down('md')]: {
          minWidth: pxToRem(40),
          padding: `${pxToRem(11)}`,
        },
        '& .btn-txt': {
          display: 'flex',
          color: '#FFFFFF',
          alignItems: 'center',

          '& .filterCount': {
            width: pxToRem(16),
            height: pxToRem(16),
            backgroundColor: '#FFFFFF',
            borderRadius: pxToRem(8),
            color: '#FF8707',
            ...theme.mixins.marginLeft(8),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          '& svg': {
            ...theme.mixins.marginRight(8),
            [theme.breakpoints.down('md')]: {
              ...theme.mixins.marginRight(0),
            },
          }
        }
      },
      '&.mobileInterests': {
        width: '100%',
        backgroundColor: '#fff',
        borderColor: '#fff',
        color: '#000',
        borderRadius: '0px',
        borderBottomRightRadius: '20px',
        '& .btn-txt': {
          display: 'flex',
          color: '#000',
          alignItems: 'center',
          '& svg': {
            ...theme.mixins.marginRight(8),
          }
        }
      },
      '&.mobileFilter': {
        width: '100%',
        backgroundColor: '#000',
        borderColor: '#000',
        '& .btn-txt': {
          display: 'flex',
          alignItems: 'center',
          color: '#FFFFFF',
          '& svg': {
            ...theme.mixins.marginRight(8),
          }
        }
      },
      '& .btn-txt': {
        color: '#565A5C'
      }
    },
    // },
    destinationScrollThumb: {
      backgroundColor: '#D9D9D9',
      cursor: 'pointer',
      borderRadius: pxToRem(5),
      overflow: 'hidden',
    },
    destinationScrollTrack: {
      ...theme.mixins.right(11),
      // right: '8px',
      width: '5px !important',
      height: '100%',
      top: '0px',
    },
    mainHeadingContainer: {
      position: 'relative',
      zIndex: 999,
      marginBottom: pxToRem(50),
      [theme.breakpoints.down('md')]: {
        marginBottom: pxToRem(24),
      },
      '& .ctaWrapper': {
        backgroundColor: '#fff',
        padding: '16px 20px',
      },
      '& .editMenu': {
        marginTop: pxToRem(15),
        backgroundColor: '#fff',
        borderRadius: '10px',
        overflow: 'hidden',
        zIndex: 99,
        position: 'absolute',
        // right: 0,
        ...theme.mixins.right(0),
        // maxWidth: pxToRem(369),
        '& .MuiList-padding': {
          padding: 0,
          '& .MuiButtonBase-root': {
            padding: 0,
            '& .MuiListItemText-root': {
              margin: 0
            }
          }
        },

      }
    }
  };
});

export default useStyles;
